export default __webpack_public_path__ + "static/media/MochaMattari.5caf2f34.woff2";